import React from 'react';
import { ONBOARDING_FLAG_WEB_NEW_REGISTER } from 'constants/featureFlagging';
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import { InitialStepForm } from './InitialStepForm/InitialStepFormContainer';
import { InitialStepFormV2 } from './InitialStepForm.v2/InitialStepFormContainer.v2';
import { INITIAL_STATE } from './useSections';

const InitialStepDispatcherComponent = ({ flags, promoCode, promotionalCode }) => {
    const isV2InitialStepActivated = flags.get(ONBOARDING_FLAG_WEB_NEW_REGISTER);

    if (isV2InitialStepActivated) {
        return (
            <InitialStepFormV2
                promoCode={promoCode}
                promotionalCode={promotionalCode}
                initialStateSections={INITIAL_STATE}
            />
        );
    }

    return <InitialStepForm promoCode={promoCode} promotionalCode={promotionalCode} />;
};

export const InitialStepDispatcher = withFeatureToggling(InitialStepDispatcherComponent);
